"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { ArrowRight, Mail } from "lucide-react";
const ContactForm = () => {
  const $ = _c(20);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 pointer-events-none"><div className="absolute left-[50%] top-0 bottom-0 w-px bg-[#F4EFE6]/[0.03]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      x: -30
    };
    t2 = {
      opacity: 1,
      x: 0
    };
    t3 = {
      once: true
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-center gap-2 sm:gap-3 mb-5 sm:mb-8"><div className="w-8 h-px bg-[#DF6D2A]" /><span className="font-body text-[10.5px] tracking-[0.25em] uppercase text-[#DF6D2A] font-light">Official Inquiries</span></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h2 className="font-display text-[36px] sm:text-[44px] md:text-[48px] lg:text-[60px] font-light leading-[1.05] text-[#F4EFE6] mb-4 sm:mb-6">Initiate <br /><em className="text-[#DF6D2A] italic">Correspondence</em></h2>;
    t7 = <p className="font-body text-[14px] sm:text-[15.5px] font-light text-white/60 leading-[1.7] sm:leading-[1.8] max-w-[400px]">We highly value contributions from researchers, descendants, and cultural institutions. Please provide your details below and a representative from the Council will respond to your inquiry directly.</p>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <motion.div initial={t1} whileInView={t2} viewport={t3} transition={t4} className="w-full lg:w-[35%] flex flex-col pt-4">{t5}{t6}{t7}<div className="mt-8 sm:mt-12 w-14 h-14 sm:w-20 sm:h-20 border border-white/10 rounded-full flex items-center justify-center bg-white/5"><Mail strokeWidth={1} size={24} className="text-[#C9A84C] sm:hidden" /><Mail strokeWidth={1} size={32} className="text-[#C9A84C] hidden sm:block" /></div></motion.div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t11;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      opacity: 0,
      x: 30
    };
    t10 = {
      opacity: 1,
      x: 0
    };
    t11 = {
      once: true
    };
    $[9] = t10;
    $[10] = t11;
    $[11] = t9;
  } else {
    t10 = $[9];
    t11 = $[10];
    t9 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      duration: 0.8,
      delay: 0.2,
      ease: [0.16, 1, 0.3, 1]
    };
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="flex flex-col group"><label className="font-display text-[18px] sm:text-[20px] md:text-[24px] text-[#C9A84C] mb-3 sm:mb-4 flex items-center gap-2 sm:gap-3"><span className="font-body text-[11px] text-white/30 tracking-[0.2em] -mt-1">01.</span>Full Name</label><input type="text" required={true} placeholder="Enter your name" className="w-full bg-transparent border-b border-white/15 pb-3 sm:pb-4 text-[15px] sm:text-[17px] text-[#F4EFE6] focus:border-[#DF6D2A] focus:outline-none transition-colors placeholder:text-white/20 font-body" /></div>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="grid grid-cols-1 md:grid-cols-2 gap-7 sm:gap-10 md:gap-12">{t13}<div className="flex flex-col group"><label className="font-display text-[18px] sm:text-[20px] md:text-[24px] text-[#C9A84C] mb-3 sm:mb-4 flex items-center gap-2 sm:gap-3"><span className="font-body text-[11px] text-white/30 tracking-[0.2em] -mt-1">02.</span>Email Address</label><input type="email" required={true} placeholder="Enter your email" className="w-full bg-transparent border-b border-white/15 pb-3 sm:pb-4 text-[15px] sm:text-[17px] text-[#F4EFE6] focus:border-[#DF6D2A] focus:outline-none transition-colors placeholder:text-white/20 font-body" /></div></div>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <label className="font-display text-[18px] sm:text-[20px] md:text-[24px] text-[#C9A84C] mb-3 sm:mb-4 flex items-center gap-2 sm:gap-3"><span className="font-body text-[11px] text-white/30 tracking-[0.2em] -mt-1">03.</span>Subject of Inquiry</label>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <select required={true} className="w-full bg-transparent border-b border-white/15 pb-3 sm:pb-4 text-[15px] sm:text-[17px] text-[#F4EFE6] focus:border-[#DF6D2A] focus:outline-none transition-colors appearance-none font-body cursor-pointer"><option value="" className="bg-[#0F1C2E]">Select a topic...</option><option value="research" className="bg-[#0F1C2E]">Research Collaboration</option><option value="archive" className="bg-[#0F1C2E]">Archive Submission</option><option value="press" className="bg-[#0F1C2E]">{"Press & Media Inquiry"}</option><option value="general" className="bg-[#0F1C2E]">General Inquiry</option></select>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="flex flex-col group relative">{t15}{t16}<div className="absolute right-2 bottom-5 pointer-events-none"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke="#F4EFE6" strokeOpacity="0.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg></div></div>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="flex flex-col group"><label className="font-display text-[18px] sm:text-[20px] md:text-[24px] text-[#C9A84C] mb-3 sm:mb-4 flex items-center gap-2 sm:gap-3"><span className="font-body text-[11px] text-white/30 tracking-[0.2em] -mt-1">04.</span>Your Message</label><textarea required={true} rows={4} placeholder="Please detail your inquiry here..." className="w-full bg-transparent border-b border-white/15 pb-3 sm:pb-4 text-[15px] sm:text-[17px] text-[#F4EFE6] focus:border-[#DF6D2A] focus:outline-none transition-colors placeholder:text-white/20 font-body resize-none leading-[1.6]" /></div>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <section className="bg-[#0F1C2E] py-16 sm:py-24 md:py-32 relative overflow-hidden border-t border-[#F4EFE6]/10">{t0}<div className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8 relative z-10"><div className="flex flex-col lg:flex-row gap-10 sm:gap-12 lg:gap-24">{t8}<motion.div initial={t9} whileInView={t10} viewport={t11} transition={t12} className="w-full lg:w-[65%]"><form className="flex flex-col gap-7 sm:gap-10 md:gap-14 bg-[#142338] p-5 sm:p-8 md:p-14 border border-white/5 shadow-2xl">{t14}{t17}{t18}<div className="pt-6"><button type="button" className="btn-primary w-full sm:w-auto inline-flex items-center justify-center gap-3 sm:gap-4 px-8 sm:px-10 py-4 sm:py-5 font-body text-[12px] sm:text-[13px] tracking-[0.12em] sm:tracking-[0.15em] uppercase font-medium hover:bg-[#F4EFE6] hover:text-[#0F1C2E] transition-colors duration-500 group">Send Message<ArrowRight size={18} strokeWidth={1.5} className="group-hover:translate-x-1 transition-transform" /></button></div></form></motion.div></div></div></section>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  return t19;
};
export default ContactForm;